var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "regist min-h-screen flex font-sans bg-background text-on-surface"
  }, [_c('aside', {
    staticClass: "hidden lg:flex w-[400px] min-h-screen flex-shrink-0 flex-col justify-between py-16 px-12 relative overflow-hidden",
    staticStyle: {
      "background-color": "#1a2035"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "absolute top-0 right-0 w-[1px] h-full bg-gradient-to-b from-transparent via-white/10 to-transparent"
  }), _vm._m(1), _c('div', {
    staticClass: "relative z-10 space-y-4"
  }, [_c('p', {
    staticClass: "font-sans text-[10px] text-white/30 tracking-widest mb-5 uppercase"
  }, [_vm._v(" " + _vm._s(_vm.uuid ? $t("yurqcq7", "请选择绑定方式") : $t("xvjo417", "请选择注册方式")) + " ")]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "regist-step-dot",
    class: _vm.step >= 1 ? 'regist-step-dot--active' : 'regist-step-dot--idle'
  }, [_vm._v(" 1 ")]), _c('span', {
    staticClass: "font-sans text-xs",
    class: _vm.step >= 1 ? 'text-white/70' : 'text-white/30'
  }, [_vm._v(` ${$t("exld2z7", "手机 / 邮箱")} `)])]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "regist-step-dot",
    class: _vm.step >= 2 ? 'regist-step-dot--active' : 'regist-step-dot--idle'
  }, [_vm._v(" 2 ")]), _c('span', {
    staticClass: "font-sans text-xs",
    class: _vm.step >= 2 ? 'text-white/70' : 'text-white/30'
  }, [_vm._v(` ${$t("8mg9yc5", "发送验证码")} `)])]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "regist-step-dot",
    class: _vm.step >= 3 ? 'regist-step-dot--active' : 'regist-step-dot--idle'
  }, [_vm._v(" 3 ")]), _c('span', {
    staticClass: "font-sans text-xs",
    class: _vm.step >= 3 ? 'text-white/70' : 'text-white/30'
  }, [_vm._v(" " + _vm._s(_vm.uuid ? $t("ymssd97", "同意协议并绑定") : $t("ympopk7", "同意协议并注册")) + " ")])])]), _c('div', {
    staticClass: "relative z-10"
  }, [_vm._m(2), _c('p', {
    staticClass: "font-sans text-[10px] text-white/15"
  }, [_vm._v(" © " + _vm._s(new Date().getFullYear()) + ` ${$t("78a1spc", "杭州绿云软件股份有限公司")} `)])])]), _c('main', {
    staticClass: "flex-1 flex flex-col min-h-screen bg-background"
  }, [_c('header', {
    staticClass: "flex justify-between items-center px-10 py-5 border-b border-border-light"
  }, [_vm._m(3), _c('div', {
    staticClass: "flex items-center space-x-6"
  }, [!_vm.uuid ? _c('FootLanguage') : _vm._e()], 1)]), _c('div', {
    staticClass: "flex-1 flex items-center justify-center px-8 py-16"
  }, [_c('div', {
    staticClass: "w-full max-w-md"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "font-sans text-xs tracking-[0.3em] text-secondary mb-3"
  }, [_vm._v(" iWork · " + _vm._s(_vm.uuid ? $t("fue48h4", "立即绑定") : $t("fub0ks4", "立即注册")) + " ")]), _c('h2', {
    staticClass: "text-4xl font-serif tracking-tight text-on-surface mb-3"
  }, [_vm._v(" " + _vm._s(_vm.uuid ? $t("fue48h4", "立即绑定") : $t("fub0ks4", "立即注册")) + " ")]), _c('p', {
    staticClass: "font-sans text-sm text-on-surface-variant"
  }, [_vm._v(" " + _vm._s(_vm.step === 1 ? _vm.uuid ? $t("yurqcq7", "请选择绑定方式") : $t("xvjo417", "请选择注册方式") : _vm.uuid ? $t("b59p4w7", "请完成您的绑定") : $t("b5cssl7", "请完成您的注册")) + " ")])]), _vm.scanReady ? [_vm.scanLoginInfo.expire === 0 ? [_vm._m(4)] : [_vm.scanLoginInfo.downstream ? _c('div', {
    staticClass: "space-y-5"
  }, [_c('ProForm', {
    ref: "bindNew",
    attrs: {
      "columns": _vm.columns,
      "label-width": 300,
      "label-position": "top"
    },
    model: {
      value: _vm.submitForm,
      callback: function ($$v) {
        _vm.submitForm = $$v;
      },
      expression: "submitForm"
    }
  }), _c('button', {
    staticClass: "regist-btn w-full",
    on: {
      "click": _vm.bindNew
    }
  }, [_vm._v(` ${$t("fue48h4", "立即绑定")} `)]), _c('p', {
    staticClass: "font-sans text-xs text-on-surface-variant"
  }, [_vm._v(` ${$t("97wywnm", "若无账号,请联系企业IT管理员进行通讯录同步")} `)])], 1) : [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step === 1,
      expression: "step === 1"
    }],
    staticClass: "select-regist-type"
  }, [_c('button', {
    staticClass: "regist-method-card w-full",
    on: {
      "click": function ($event) {
        return _vm.setStep(2, 'MOBILE');
      }
    }
  }, [_vm._m(5)]), _vm._m(6), _c('button', {
    staticClass: "regist-method-card w-full",
    on: {
      "click": function ($event) {
        return _vm.setStep(2, 'EMAIL');
      }
    }
  }, [_vm._m(7)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step === 2,
      expression: "step === 2"
    }],
    staticClass: "select-regist-input"
  }, [_c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.regist.formData,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regist.loginType === 'MOBILE',
      expression: "regist.loginType === 'MOBILE'"
    }],
    attrs: {
      "label": $t("ewbd43", "手机号")
    }
  }, [_c('CountryCode', {
    ref: "countryCode",
    staticClass: "country_code",
    model: {
      value: _vm.regist.formData,
      callback: function ($$v) {
        _vm.$set(_vm.regist, "formData", $$v);
      },
      expression: "regist.formData"
    }
  })], 1), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.regist.loginType === 'EMAIL',
      expression: "regist.loginType === 'EMAIL'"
    }],
    attrs: {
      "label": $t("padf2", "邮箱"),
      "rules": _vm.rules.email,
      "prop": "email"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("padf2", "邮箱"),
      "element-id": "registFormInputEmail"
    },
    on: {
      "input": () => _vm.onInputRange(this, _vm.regist.formData, 'email', 'registFormInputEmail')
    },
    model: {
      value: _vm.regist.formData.email,
      callback: function ($$v) {
        _vm.$set(_vm.regist.formData, "email", $$v);
      },
      expression: "regist.formData.email"
    }
  })], 1), _c('button', {
    staticClass: "regist-btn w-full mt-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleContinueVerfy
    }
  }, [_vm._v(` ${$t("8mg9yc5", "发送验证码")} `), _c('span', {
    staticClass: "material-symbols-outlined ml-2",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("arrow_forward")])])], 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step === 3,
      expression: "step === 3"
    }],
    staticClass: "space-y-4"
  }, [_c('LoginVerificationCode', {
    key: _vm.step,
    ref: "verificationCode",
    on: {
      "on-resend": _vm.handleResend,
      "complete": _vm.onCompleteVerify
    }
  }), _c('Agreenment', {
    model: {
      value: _vm.regist.agreed,
      callback: function ($$v) {
        _vm.$set(_vm.regist, "agreed", $$v);
      },
      expression: "regist.agreed"
    }
  }), _c('button', {
    staticClass: "regist-btn w-full",
    class: {
      'regist-btn--loading': _vm.loading
    },
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleContinueSubmit
    }
  }, [_vm.loading ? _c('span', {
    staticClass: "material-symbols-outlined mr-2",
    staticStyle: {
      "font-size": "18px",
      "animation": "spin 1s linear infinite"
    }
  }, [_vm._v("progress_activity")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.uuid ? $t("ymssd97", "同意协议并绑定") : $t("ympopk7", "同意协议并注册")) + " "), !_vm.loading ? _c('span', {
    staticClass: "material-symbols-outlined ml-2",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("arrow_forward")]) : _vm._e()])], 1)]]] : _vm._e(), !_vm.uuid ? _c('div', {
    staticClass: "mt-8 font-sans text-xs"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step === 1,
      expression: "step === 1"
    }],
    staticClass: "text-on-surface-variant hover:text-secondary cursor-pointer transition-colors inline-flex items-center gap-1",
    on: {
      "click": function ($event) {
        return _vm.goToOther('Login');
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("arrow_back")]), _vm._v(` ${$t("iid7444", "返回登录")} `)]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.step !== 1,
      expression: "step !== 1"
    }],
    staticClass: "text-on-surface-variant hover:text-secondary cursor-pointer transition-colors inline-flex items-center gap-1",
    on: {
      "click": _vm.onBack
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("arrow_back")]), _vm._v(` ${$t("oxvu2", "返回")} `)])]) : _vm._e()], 2)])]), _c('Verify', {
    ref: "verify",
    attrs: {
      "captcha-type": 'blockPuzzle',
      "img-size": {
        width: '300px',
        height: '200px'
      }
    },
    on: {
      "close": _vm.handleCloseVerify,
      "success": _vm.handleSuccessVerify
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "absolute inset-0 opacity-[0.03]"
  }, [_c('div', {
    staticClass: "absolute top-0 left-0 w-full h-full",
    staticStyle: {
      "background-image": "repeating-linear-gradient(",
      "background-size": "24px 24px"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative z-10"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 mb-16"
  }, [_c('div', {
    staticClass: "w-9 h-9 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }, [_c('img', {
    staticClass: "w-[22px] h-[22px]",
    attrs: {
      "src": require("@/assets/iwork-logo.png"),
      "alt": "",
      "aria-hidden": "true"
    }
  })]), _c('span', {
    staticClass: "font-serif text-white text-2xl tracking-tight"
  }, [_vm._v("iWork")])]), _c('h1', {
    staticClass: "text-4xl font-serif text-white leading-snug mb-4"
  }, [_vm._v(` ${$t("ya5vrn5", "一站式工作")}`), _c('br'), _vm._v(`${$t("aucsqy4", "协作平台")} `)]), _c('p', {
    staticClass: "font-sans text-[10px] text-white/30 tracking-[0.25em] mb-10 uppercase"
  }, [_vm._v(` ${$t("78a1spc", "杭州绿云软件股份有限公司")} `)]), _c('p', {
    staticClass: "font-sans text-sm text-white/40 leading-relaxed max-w-xs"
  }, [_vm._v(` ${$t("5ta8t629", "作为酒店数字化生态中枢，深度聚合绿云 PMS、Oracle Hospitality、数据与营销四大核心业务。基于统一身份认证，为全员提供高效、安全的专属工作入口。")} `)])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center space-x-2 mb-3"
  }, [_c('span', {
    staticClass: "w-1.5 h-1.5 rounded-full animate-pulse",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }), _c('span', {
    staticClass: "font-sans text-[10px] text-white/30 tracking-widest"
  }, [_vm._v($t("s0e17vc", "iWork 服务运行正常"))])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center space-x-2.5 lg:hidden"
  }, [_c('div', {
    staticClass: "w-7 h-7 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }, [_c('img', {
    staticClass: "w-[16px] h-[16px]",
    attrs: {
      "src": require("@/assets/iwork-logo.png"),
      "alt": "",
      "aria-hidden": "true"
    }
  })]), _c('span', {
    staticClass: "font-serif text-on-surface text-lg"
  }, [_vm._v("iWork")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "text-center py-12"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-on-surface-dim text-[48px] mb-4 block"
  }, [_vm._v("qr_code_2")]), _c('p', {
    staticClass: "font-sans text-sm text-on-surface-variant"
  }, [_vm._v(` ${$t("oy3uycc", "二维码已失效,请重新扫码")} `)])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-10 h-10 rounded-xl bg-surface-container-low flex items-center justify-center flex-shrink-0"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-on-surface-variant",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("smartphone")])]), _c('div', {
    staticClass: "text-left flex-1"
  }, [_c('p', {
    staticClass: "font-sans text-sm font-medium text-on-surface"
  }, [_vm._v(` ${$t("haa72", "手机")} `)]), _c('p', {
    staticClass: "font-sans text-xs text-on-surface-variant mt-0.5"
  }, [_vm._v(` ${$t("ewbd43", "手机号")} `)])]), _c('span', {
    staticClass: "material-symbols-outlined text-on-surface-dim",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("chevron_right")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center gap-3 my-4"
  }, [_c('div', {
    staticClass: "flex-1 h-px bg-border-light"
  }), _c('span', {
    staticClass: "font-sans text-xs text-on-surface-dim"
  }, [_vm._v("or")]), _c('div', {
    staticClass: "flex-1 h-px bg-border-light"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-10 h-10 rounded-xl bg-surface-container-low flex items-center justify-center flex-shrink-0"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-on-surface-variant",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("email")])]), _c('div', {
    staticClass: "text-left flex-1"
  }, [_c('p', {
    staticClass: "font-sans text-sm font-medium text-on-surface"
  }, [_vm._v(` ${$t("padf2", "邮箱")} `)]), _c('p', {
    staticClass: "font-sans text-xs text-on-surface-variant mt-0.5"
  }, [_vm._v(` ${$t("padf2", "邮箱")} `)])]), _c('span', {
    staticClass: "material-symbols-outlined text-on-surface-dim",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("chevron_right")])]);
}];
export { render, staticRenderFns };